// extracted by mini-css-extract-plugin
module.exports = {"paramsHeader":"SectionProvisions_paramsHeader_1WLqf"};